import { Translate } from '@dreryk/react-common';
import { Link, Notification, NotificationType, StyledFlex } from '@dreryk/react-components';

import { invoicePanelTranslationKeys } from '../../translations';
import { openUrlInNewTab } from '../utils';

type IntegrationEnabledInfoProps = {
   readonly invoiceOfferUrl: string;
};

export const IntegrationEnabledInfo = (props: IntegrationEnabledInfoProps): JSX.Element => {
   return (
      <Notification
         testId={'integrationEnabled'}
         type={NotificationType.SUCCESS}
         label={
            <StyledFlex alignItems={'center'} gap={4}>
               <Translate>{invoicePanelTranslationKeys.integrationEnabled}</Translate>
               <Link
                  testId={'invoiceCurrentOffer'}
                  onClick={openUrlInNewTab(props.invoiceOfferUrl)}
                  label={invoicePanelTranslationKeys.invoiceCurrentOffer}
               />
            </StyledFlex>
         }
      />
   );
};
